import ProductPagination from '@/components/ProductPagination/ProductPagination';

export default ProductPagination;
